import React from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselContent,
} from '@americanexpress/dls-react';
/* eslint-disable  import/no-cycle -- need */
import { constructChildStructure } from '../ChildConstructor';
/* eslint-disable max-len -- need */
const DlsCarousel = (carouselProps) => {
  const {
    autoplay = true,
    heading = 'Carousel',
    interval = '5000',
    type = 'full-width',
    corouselItems = [],
    props,
  } = carouselProps;
  return (
    <Carousel
      autoplay={autoplay}
      heading={heading}
      animate={true}
      interval={interval}
      type={type}
    >
      {
            corouselItems.length > 0
                && corouselItems.map((corouselItem) => (
                  <CarouselItem
                    key={corouselItem.id}
                    id={corouselItem.id}
                    backgroundImageUrl={corouselItem.backgroundImageUrl}
                  >
                    <CarouselContent
                      theme={corouselItem.theme ? corouselItem.theme : {}}
                    >
                      <div className="">
                        {constructChildStructure(corouselItem.childElements, props, corouselItem.id)}
                      </div>
                    </CarouselContent>
                  </CarouselItem>
                ))

        }
    </Carousel>
  );
};
/* eslint-enable max-len -- need */
/* eslint-enable  import/no-cycle -- need */
DlsCarousel.propTypes = {};

export default DlsCarousel;
